export const uriParser = (uri) => {
    const a = document.createElement('a');
    a.href = uri;
    return a;
};
export const compose = (fn1, ...fns) => fns.reduce((prevFn, nextFn) => value => prevFn(nextFn(value)), fn1);
